import React from 'react';
import { Image } from 'react-bootstrap';

function TabCard({
    assetImg,
    title,
    subtitle,
    width,
    height,
    active,
    onClick
}) {

  return (
    <>
        <ul className='nav nav-pills d-flex justify-content-between nav-pills-custom gap-3 mb-6'>
            <li className='nav-item mb-3 me-0'>
                <button 
                className={`nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-primary flex-column flex-stack pt-9 pb-7 page-bg show ${active ? 'active' : ''}`} 
                type='button' 
                data-bs-toggle='pill' 
                data-bs-target='#kt_tab_pane_1' 
                style={{ width: width,height: height }}
                onClick={onClick}
                >
                        <div className='nav-icon mb-3'>
                            <Image 
                            src={assetImg} 
                            className='w-50px h-50px' 
                            alt='image' />
                            
                        </div>
                        <div className=''>
                            <span 
                            className="text-gray-800 fw-bold d-block"
                            style={{ width: '100%', fontSize: 'clamp(11px, 1vw, 11px)'}}
                            >{title}</span>
                            <span 
                            className="text-gray-400 fw-semibold"
                            style={{ width: '100%', fontSize: 'clamp(10px, 1vw, 10px)'}}
                            >{subtitle}</span>
                        </div>
                </button>
            </li>
        </ul>
    </>
  );
}

export default TabCard;
